<template>
	<core-page class="omapi-monsterleads-wrapper">
		<monsterleads-not-connected v-if="!connected && !isLoading"/>
		<div v-else>
			<common-alerts :alerts="alerts"/>
			<common-tabnav
				:active="currentTab"
				:tabs="allTabs"
				@go="navTo"
			/>
			<component :is="`monsterleads-${this.currentTab}`"/>
		</div>
		<monsterleads-modal-export/>
	</core-page>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { tabs } from '@/pages/mixins/tabs'

export default  {
	mixins : [ tabs ],
	data () {
		return {
			pageSlug : 'monsterleads',
		}
	},
	computed : {
		...mapState([ 'alerts' ]),
		...mapGetters([ 'connected', 'shouldFetchUser' ]),
		isLoading () {
			return this.shouldFetchUser || this.$store.getters.isLoading('monsterleads')
		},
	},
}
</script>

<style lang="scss">
	.omapi-datepicker-inline {
		display: flex;
		justify-content: space-between;
	}
</style>
